import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils';

export const getNotificationItem = createAsyncThunk('notification/getNotification',
  async (date: string) => {
    const url = `v1/dashboard-notifications${serializeQueryParam({ date })}`
    const response: AxiosResponse<NotificationState> = await instance.get(url)
    return response.data
  })

export const updateNotificationItem = createAsyncThunk('notification/updateNotificationItem',
  async (id: string) => {
    const url = `v1/dashboard-notifications/${id}/read`
    const response: AxiosResponse<{access_token: string}> = await instance.patch(url)
    return response.data
  })
